import Home from "./home/Home";
import Blog from "./blog/Blog";
import Projects from "./projects/Projects";
import Resume from "./resume/Resume";
import Services from "./services/Services";

//import NotFoundPage from "./utilityPages/NotFoundPage";
//import CommingSoonPage from "./utilityPages/CommingSoonPage";
//import Contributes from "./contributes/Contributes";

export default {
  HomeView: Home,
  BlogView: Blog,
  ProjectsView: Projects,
  ResumeView: Resume,
  ServicesView: Services
  //NotFoundView: NotFoundPage,
  //CommingSoonView: CommingSoonPage,
  //contributesView: Contributes,
};
